<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="paramAddEditTemplate.mode ==='i'" >Add New <strong> Template </strong></p>
                <p class="modal-card-title " v-if="paramAddEditTemplate.mode ==='u'" >Update <strong> Template </strong></p>
            </header>
            <section class="modal-card-body">
<TemplateLoadStatus :detail-loading="templateDetailLoading" :detail-error="templateDetailError" @retry-detail="retryTemplateDetail" />


<!--         :editor-toolbar="customToolbar"      <h1>Add/Edit Template</h1>-->
<!--                {{paramAddEditTemplate.mode}} <br>-->
<!--                {{paramAddEditTemplate.id}}-->
 
             <b-tabs v-if="paramAddEditTemplate.mode === 'i' || templateEditReady" v-model="activeTab">
                 <b-tab-item label="Edit">
                     <b-field label="Title">
                         <b-input v-model="titleTemplate" ></b-input>
                     </b-field>
                     <b-field label="Description">
                         <vue-editor v-model="dataEditorTemplate"
                                     id="editor"
                                     :editor-toolbar="customToolbar"
                         />
                     </b-field>
                     <nav class="level">
                         <div class="level-left">
                             &nbsp;
                         </div>
                         <div class="level-right">
                             <!--                        <div class="level-item">-->
                             <!--                            <p class="is-size-6  has-text-grey "> {{countText}}/550</p>-->
                             <!--                        </div>-->
                         </div>
                     </nav>
                 </b-tab-item>
                 <b-tab-item label="Preview">

                         <div v-html="titleTemplate"></div>


                         <div v-html="dataEditorTemplate"></div>
                   
                 </b-tab-item>


             </b-tabs>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger" @click="close">Close</b-button>
                &nbsp;
                <b-button type="is-success" :disabled="templateDetailLoading || (paramAddEditTemplate.mode === 'u' && !templateEditReady)" @click="saveDat">Save</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import templateCatalogue from '@/mixins/templateCatalogue'
    /* eslint-disable no-console */
    import htmlToText from "html-to-text";
    import axios from "axios";
    import {getConfigAxios , getBaseURLforBackEnd ,genUUID }  from '@/utils.js'
    import { mapState } from "vuex";

    export default {
        name: "AddEditTemplate",
        mixins: [templateCatalogue],
        mounted() { if (this.paramAddEditTemplate.mode === 'u') this.loadTemplateDetail() },
        methods:{
            async loadTemplateDetail() {
                if (this.templateDetailLoading) return
                this.templateDetailLoading = true
                this.templateDetailError = ''
                this.templateRetry = () => this.loadTemplateDetail()
                const epoch = this.$store.state.mytemplateTxt.epoch
                try {
                    const data = await this.$store.dispatch('mytemplateTxt/ensureDetail', this.paramAddEditTemplate.id)
                    if (this.templateDisposed || epoch !== this.$store.state.mytemplateTxt.epoch) return
                    this.titleTemplate = data.title
                    this.dataEditorTemplate = data.content_html
                    this.templateEditReady = true
                } catch (error) {
                    if (!this.templateDisposed) this.templateDetailError = 'โหลดเนื้อหา template ไม่สำเร็จ'
                } finally { this.templateDetailLoading = false }
            },

            saveDat(){
                if (this.paramAddEditTemplate.mode === 'u' && !this.templateEditReady) return
                   // if(this.getTextFromHTML.length>1000){
                   //     this.$buefy.dialog.alert({
                   //         title: 'Error',
                   //         message: `Error Data Content has more than 1,000 char`,
                   //         type: 'is-danger',
                   //         hasIcon: true,
                   //         icon: 'times-circle',
                   //         iconPack: 'fa',
                   //         ariaRole: 'alertdialog',
                   //         ariaModal: true
                   //     })
                   // }else if(this.titleTemplate.length>100){
                   //     this.$buefy.dialog.alert({
                   //         title: 'Error',
                   //         message: `Error Data Title has more than 100 char`,
                   //         type: 'is-danger',
                   //         hasIcon: true,
                   //         icon: 'times-circle',
                   //         iconPack: 'fa',
                   //         ariaRole: 'alertdialog',
                   //         ariaModal: true
                   //     })
                   // }else{
                       // do next
                       if (this.paramAddEditTemplate.mode === 'i'){
                           this.insertNew()
                       }
                       if (this.paramAddEditTemplate.mode === 'u'){
                           this.updateData()
                       }

                   // }
            },
            updateData(){
                //updatetemplatenonautomate

                const datTo ={
                    "id" : this.paramAddEditTemplate.id ,
                    "title":  this.titleTemplate.length === 0 ? genUUID(5) : this.titleTemplate  ,
                    // "context_html"  : this.dataEditorTemplate ,
                    "context_html"  : Buffer.from(this.dataEditorTemplate).toString('base64') ,
                    "content_txt"   : this.getTextFromHTML
                }

                // console.log(JSON.stringify(datTo))

                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatetemplatenonautomate`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `${res.data.msg}`,
                                type: 'is-success'
                            })
                            vm.$store.dispatch('mytemplateTxt/invalidate')
                            vm.closeAddEditModalWithChange()
                        }
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `err ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },
            insertNew(){
                const datTo ={
                    "title":   this.titleTemplate.length === 0 ? genUUID(5) : this.titleTemplate  ,
                    "context_html"  : this.dataEditorTemplate ,
                    "content_txt"   : this.getTextFromHTML
                }
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/addnewtemplatenonautomate`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `${res.data.msg}`,
                                type: 'is-success'
                            })
                            vm.$store.dispatch('mytemplateTxt/invalidate')
                            vm.closeAddEditModalWithChange()
                        }
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },
            close(){
                this.$emit('close')
            },
            closeAddEditModalWithChange(){
                this.$emit('closeAddEditModalWithChange')
            }
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
            countText(){
                let text = this.dataEditorTemplate.replace(/<\/?[^>]+(>|$)/g, '');
                let len = text.length;
                return len;
            },
            getTextFromHTML:function () {
                return  htmlToText.fromString(this.dataEditorTemplate, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },

        },
        props:{
            paramAddEditTemplate :{ mode: "",id: ""} // mode i === insert , u === update
        },
        data(){
            return {
                templateEditReady: false,
                activeTab : 0 ,
                titleTemplate : "",
                dataEditorTemplate : "",
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                    // [{ 'script': 'sub'}, { 'script': 'super' }],
                ]
            }
        }
    }
</script>

<style scoped>

</style>